import {
  Typography,
  List,
  ListItem,
  ListSubheader,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box
} from '@mui/material'
import {faqData} from './faqJson'
import {useTheme} from '@mui/material/styles'
import PropTypes from 'prop-types'

const accordionStyle = {
  borderRadius: '6px',
  border: 'none',
  boxShadow: 'none',
  '::before': {
    backgroundColor: 'transparent'
  }
}

const TableOfContents = ({
  handleItemClick,
  isAccordionActive,
  setIsAccordionActive,
  handleAccordionTitleChange,
  isAccordionTitleChange,
  expandedAccordion,
  setExpandedAccordion,
  setIsActive,
  isActive
}) => {
  const theme = useTheme()
  const handleAccordionChange = (title) => {
    setExpandedAccordion(expandedAccordion === title ? '' : title)
  }

  return (
    <Box sx={{maxHeight: 'calc(100vh + 30px)', overflowY: 'auto', scrollbarWidth: 'none'}}>
      <List component='nav' sx={{borderLeft: '1px solid', paddingTop: 0, paddingBottom: 0, marginTop: '8px'}}>
        <ListSubheader
          sx={{
            fontWeight: theme.typography.fontWeightSemibold,
            color: theme.palette.hpBaseDark,
            fontSize: theme.typography.h6.fontSize,
            position: 'unset',
            lineHeight: '16px'
          }}
        >
          CONTENTS
        </ListSubheader>
        {Object.keys(faqData).map((title) => (
          <Accordion
            key={title}
            disableGutters
            sx={accordionStyle}
            expanded={expandedAccordion === title}
            onChange={() => {
              handleAccordionChange(title)
              handleAccordionTitleChange(title)
              setIsAccordionActive('')
              setIsActive('')
              handleItemClick(title)
            }}
          >
            <AccordionSummary
              aria-controls='panel1a-content'
              sx={{
                maxHeight: '32px',
                minHeight: 0,
                marginTop: '16px',
                borderLeft: isAccordionTitleChange === title ? `2px solid ${theme.palette.hpPrimaryDark}` : 'none'
              }}
            >
              <ListItem sx={{padding: 0}}>
                <Typography
                  data-testid='accordion-title'
                  fontSize={theme.typography.subtitle1.fontSize}
                  fontWeight={theme.typography.fontWeightRegular}
                  color={isAccordionTitleChange === title ? theme.palette.hpPrimaryDark : theme.palette.hpBaseDarker}
                >
                  {' '}
                  {title}{' '}
                </Typography>
              </ListItem>
            </AccordionSummary>

            <AccordionDetails sx={{padding: 0, marginLeft: 0}}>
              {faqData[title].Content.map((item) => (
                <ListItem
                  id={item.id}
                  key={item.id}
                  tabIndex={0}
                  data-testid={`ac-${item.title}`}
                  onClick={() => {
                    handleItemClick(item.id)
                    handleAccordionTitleChange('')
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleItemClick(item.id)
                      handleAccordionTitleChange('')
                    }
                  }}
                  sx={{
                    padding: '0 0 0 32px',
                    borderLeft:
                      isActive === item.id || isAccordionActive === item.id
                        ? `2px solid ${theme.palette.hpPrimaryDark}`
                        : 'none',
                    cursor: 'pointer'
                  }}
                >
                  <Typography
                    sx={{
                      color:
                        isActive === item.id || isAccordionActive === item.id
                          ? theme.palette.hpPrimaryDark
                          : theme.palette.hpBaseDarker,
                      fontSize: theme.typography.subtitle1.fontSize,
                      fontWeight: theme.typography.fontWeightRegular,
                      marginBottom: '5px'
                    }}
                  >
                    {item.title}
                  </Typography>
                </ListItem>
              ))}
            </AccordionDetails>
          </Accordion>
        ))}
      </List>
    </Box>
  )
}

TableOfContents.propTypes = {
  handleItemClick: PropTypes.func,
  isAccordionActive: PropTypes.number,
  setIsAccordionActive: PropTypes.func,
  handleAccordionTitleChange: PropTypes.func,
  isAccordionTitleChange: PropTypes.number,
  expandedAccordion: PropTypes.string,
  setExpandedAccordion: PropTypes.func,
  setIsActive: PropTypes.func,
  isActive: PropTypes.number
}

export default TableOfContents
